"use client"

import { Button, Heading } from "@medusajs/ui"
import { useRouter } from "next/navigation"
import { useT } from '../../../../i18n/client'
import LocalizedClientLink from "@modules/common/components/localized-client-link"


const Hero = () => {
  const router = useRouter()
  const { t } = useT('main')

  const navigateToStore = () => {
    router.push("/store")
  }

  return (
    <div className="h-[50vh] w-full border-b border-ui-border-base relative overflow-hidden">
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src="https://oprema24-assets-eu-central-1-1cf5e4.s3.eu-central-1.amazonaws.com/linea-intro.webm" type="video/webm" />
      </video>
      <div className="absolute inset-0 "></div>
      <div className="absolute inset-0 z-10 flex flex-col justify-between items-center text-center p-8">
        <div className="flex flex-col items-center gap-4">
          <Heading
            level="h1"
            className="text-3xl leading-10 text-white font-bold drop-shadow-lg"
            style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.8)' }}
          >
            Oprema 24
          </Heading>
          <Heading
            level="h2"
            className="text-3xl leading-10 text-white font-semibold drop-shadow-lg"
            style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.8)' }}
          >
            {t('slogan')}
          </Heading>
        </div>
        
        <div className="flex flex-col items-center gap-6">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="bg-green-50 border border-green-200 rounded-lg px-4 py-2">
              <span className="text-green-800 font-semibold text-lg">30% {t('discountAdvance')}</span>
            </div>
            <div className="bg-blue-50 border border-blue-200 rounded-lg px-4 py-2">
              <span className="text-blue-800 font-semibold text-lg">{t('upTo')} 24% {t('discountInstallments')}</span>
            </div>
          </div>
          
          <LocalizedClientLink href="/store">
            <Button
              variant="primary"
              className="w-70 p-3 text-xl"
              data-testid="hero-button"
            >
            {t('seeAllProducts')}
            </Button>
          </LocalizedClientLink>
        </div>
      </div>
    </div>
  )
}

export default Hero
